(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sorting"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.sorting-filter-select, .sorting-filter-radio').forEach(function(el) {
      el.addEventListener('change', function() {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        window.location.href = url.toString();
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
